import React from "react";
import { ArrowUpRight, Music2, Sparkles, UtensilsCrossed } from "lucide-react";

function ExperienceSection({ setReserveOpen }) {
  return (
    <section id="experience" className="experience">
      <div className="experience-image">
        <img src="https://images.unsplash.com/photo-1519671282429-b44660ead0a7?auto=format&fit=crop&w=2200&q=90" alt="Jalsa ambience" />
        <div className="experience-overlay" />
      </div>
      <div className="experience-content">
        <p className="kicker">THE EXPERIENCE</p>
        <h2>Come for dinner.<br /><i>Stay for the story.</i></h2>
        <p>
          From golden-hour conversations to midnight music, Jalsa is
          designed around the natural rhythm of a great evening.
        </p>
        <div className="experience-pills">
          <span><UtensilsCrossed size={16} /> Kitchen</span>
          <span><Sparkles size={16} /> Bar</span>
          <span><Music2 size={16} /> Music</span>
        </div>
        <button className="gold-btn" onClick={() => setReserveOpen(true)}>
          Plan your evening <ArrowUpRight size={18} />
        </button>
      </div>
    </section>
  );
}

export default ExperienceSection;
